<div
  id="{{ anchor }}"
  class="flex justify-between px-5 md:px-12 mb-5 md:mb-10"
>
  <h2 class="font-accent font-bold text-xl md:text-4.5xl text-neutral-800">
    {{ title }}
  </h2>
</div>
<div class="px-5 md:px-12 pb-12 flex overflow-x-auto flex-shrink-0 scrollbar-hide">
  <app-block-factory
    *ngFor="let image of images"
    [blockId]="image"
  >
  </app-block-factory>
</div>
